import type { Explanation } from '../../explanations/types';
import { commonScopes, type Translate } from '../../explanations/common';

/**
 * As métricas do Comparativo de Franquias se explicam daqui (skill `self-explaining-ui`).
 * Cada frase descreve uma coluna da view de comparativo_franquias_model no app-api,
 * calculada por franquia (chamado 2026-0025; média de itens alinhada ao Dashboard no
 * DS 2026-0082).
 */
export const comparativoFranquiasExplanations = (t: Translate): Record<string, Explanation> => {
  const SCOPE = commonScopes(t);
  const money = `${SCOPE.franchiseFilterAndPeriod} ${SCOPE.localCurrency}`;

  return {
    orcamentos_aprovados: {
      what: t('Orçamentos criados no período com status Aprovado, Parcialmente concluído ou Todos os serviços realizados.'),
      scope: SCOPE.franchiseFilterAndPeriod,
    },
    recebimentos: {
      what: t('O que de fato entrou no caixa: recebimentos com data de pagamento dentro do período.'),
      scope: money,
    },
    media_itens_orcamento: {
      what: t('Itens de serviço por orçamento, contando só orçamentos com visita realizada. É a mesma conta do Dashboard.'),
      calculation: [t('Itens dos orçamentos com visita realizada'), t('÷ número desses orçamentos')],
      scope: SCOPE.franchiseFilterAndPeriod,
    },
    cac: {
      what: t('Custo de aquisição de cliente: quanto o marketing custou por cliente novo.'),
      calculation: [t('Despesas de marketing do período'), t('÷ clientes novos do período')],
      scope: money,
    },
    conversao_orcamentos: {
      what: t('Dos orçamentos não cancelados do período, a parte que foi aprovada.'),
      calculation: [t('Orçamentos aprovados'), t('÷ orçamentos não cancelados')],
      now: { kind: 'info', text: t('Orçamento perdido vira Cancelado e sai da base, por isso o número fica perto de 100%. Conversão de venda é a "Conversão de clientes" do Dashboard.') },
      scope: SCOPE.franchiseFilterAndPeriod,
    },
    conversao_realizacao: {
      what: t('Compromissos realizados para cada 100 orçamentos não cancelados do período.'),
      calculation: [t('Compromissos realizados'), t('÷ orçamentos não cancelados')],
      scope: SCOPE.franchiseFilterAndPeriod,
    },
    iao: {
      what: t('Fatia do faturamento que veio de serviços vendidos durante a execução do compromisso. É composição do faturamento, não produtividade do operador.'),
      calculation: [t('Serviços vendidos na execução, em compromissos realizados'), t('÷ faturamento')],
      scope: money,
    },
  };
};
